export default __webpack_public_path__ + "static/media/intro-logo.2dc569e4.png";